import { Injectable, inject } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { AppConnectivityService } from './app-connectivity.service';
import { NetworkDiscoveryService } from './network-discovery.service';
import { PlatformService } from './platform.service';

@Injectable({ providedIn: 'root' })
export class MobileRuntimeService {
  private readonly platform = inject(PlatformService);
  private readonly connectivity = inject(AppConnectivityService);
  private readonly networkDiscovery = inject(NetworkDiscoveryService);

  async initialize(): Promise<void> {
    await this.connectivity.refresh();

    if (!this.platform.isNative()) {
      return;
    }

    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#f3efe4' });
    await SplashScreen.hide();

    if (!this.networkDiscovery.hasCachedDevices()) {
      await this.networkDiscovery.discover();
    }
  }
}
